/**
 * Shared enums used by the Leads list and its saved views.
 * Kept alongside the Leads sub-components so any future addition of a status
 * shows up in exactly one place.
 */
export const LEAD_STATUSES = ["new", "validated", "duplicate", "rejected", "delivered", "closed"];
export const DELIVERY_STATUSES = [
  { value: "delivered", label: "Delivered" },
  { value: "retrying", label: "Retrying" },
  { value: "scheduled", label: "Waiting for buyer hours" },
  { value: "failed_final", label: "Failed" },
  { value: "unmatched", label: "No buyer found" },
  { value: "capped", label: "Buyer at limit" },
  { value: "pending_delivery", label: "Not sent yet" },
  { value: "emergency_paused", label: "Paused" },
  { value: "sandbox_skipped", label: "Test lead" },
  { value: "not_applicable", label: "Not applicable" },
];

export const DATE_RANGE_PRESETS = [
  { label: "Today", days: 1 },
  { label: "7d", days: 7 },
  { label: "30d", days: 30 },
  { label: "90d", days: 90 },
];
